export const INPUT_HEIGHT = 42
